/**
 * API path substrings for which the axios interceptor hides success toasts.
 * Used in src/services/axiosConfig.ts so these responses don't show backend success messages.
 * - auth: login, register, send OTP, verify OTP, resend OTP (/auth/, /auth/login/, etc.)
 * - verify-otp: verify OTP endpoints (/auth/verify-otp/, /auth/verify-email/verify-otp/, etc.)
 */
export const hidenMessageAPI = [
  "user-preferences-general",
  "auth",
  "verify-otp",
  "verify-email",
];
